import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'nl',
    fullName: 'Dutch',
    nativeName: 'Nederlands',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Er komt iets geweldigs aan",
    landing_subtitle: "ArgVoid is een app- en game-ontwikkelingsstudio. Blijf ons volgen, er komen snel nieuwe dingen aan!",
    select_language: "Selecteer Taal",
    search_placeholder: "Talen zoeken...",
    terms_title: "Servicevoorwaarden",
    policy_title: "Privacybeleid",
    cookies_title: "Cookiebeleid",
    terms_content: `
        <strong>1. Acceptatie van voorwaarden</strong><br>
        Door ArgVoid te bezoeken, worden deze Servicevoorwaarden geaccepteerd. Als niet met deze voorwaarden wordt ingestemd, mag de dienst niet worden gebruikt.<br><br>

        <strong>2. Platformgebruik</strong><br>
        ArgVoid en zijn toepassingen worden geleverd "zoals ze zijn" voor informatieve en creatieve doeleinden. De service mag alleen voor legale doeleinden worden gebruikt.<br><br>

        <strong>3. Verboden gedrag</strong><br>
        Het misbruiken van kwetsbaarheden op de site, spammen of proberen ongeautoriseerde toegang te krijgen tot de infrastructuur is ten strengste verboden.<br><br>

        <strong>4. Disclaimer</strong><br>
        Het platform en de diensten kunnen op elk moment zonder voorafgaande kennisgeving worden gewijzigd. Er wordt geen garantie gegeven met betrekking tot de uptime of beschikbaarheid van de dienst.
    `,
    policy_content: `
        <strong>1. Informatieverzameling</strong><br>
        Het platform vereist op dit moment geen gebruikersauthenticatie of het aanmaken van een account. Er wordt niet actief persoonlijk identificeerbare informatie (zoals namen of e-mailadressen) verzameld van bezoekers.<br><br>

        <strong>2. Gebruiksgegevens</strong><br>
        Er kunnen eenvoudige, geanonimiseerde analyses worden verzameld om het siteverkeer te begrijpen en de applicaties te verbeteren. Deze gegevens zijn niet gekoppeld aan individuele gebruikersidentiteiten.<br><br>

        <strong>3. Diensten van derden</strong><br>
        Er kan gebruik worden gemaakt van externe providers voor hosting- en analysediensten. De privacypraktijken van deze respectieve providers zijn van toepassing op de anonieme gegevens die op hun infrastructuur worden verwerkt.<br><br>

        <strong>4. Gegevensbeveiliging</strong><br>
        Er zijn redelijke beveiligingsmaatregelen geïmplementeerd om het platform te beschermen. Geen enkele transmissiemethode via internet is echter volledig veilig.<br><br>
    `,
    cookies_content: `
        <strong>1. Wat zijn cookies en lokale opslag?</strong><br>
        Cookies en lokale browseropslag zijn kleine gegevensbestanden die op het apparaat worden opgeslagen om configuratievoorkeuren tijdens bezoeken te onthouden.<br><br>

        <strong>2. Gebruiksdoel</strong><br>
        Browser LocalStorage wordt uitsluitend gebruikt om configuratie-instellingen op te slaan, zoals:<br>
        - Taalvoorkeuren<br>
        - Configuratie van de gebruikersinterface (bijvoorbeeld lay-out- of thema-instellingen)<br>
        - Tijdelijke applicatie cache<br><br>

        <strong>3. Geen tracking</strong><br>
        Cookies en lokale opslag worden niet gebruikt voor reclame- of trackingdoeleinden van derden. Alle opgeslagen gegevens zijn uitsluitend bedoeld voor de kernfunctionaliteit van het platform.<br><br>

        <strong>4. Controle</strong><br>
        Browsergegevens kunnen op elk moment worden gewist via de browserinstellingen, waardoor alle lokale configuraties worden gereset.
    `,
    cookie_consent_text: "Wij gebruiken basiscookies om ervoor te zorgen dat de website correct functioneert, zoals het actief houden van uw sessie, het opslaan van uw taalvoorkeur en andere aangepaste configuraties.",
    read_policy: "Lees Cookiebeleid",
    support_title: "Neem contact op met ondersteuning",
    support_subject_label: "Onderwerp",
    support_message_label: "Bericht",
    support_submit_button: "Bericht verzenden",
    support_hint: "Opmerking: hierdoor wordt uw standaard e-mailtoepassing geopend om het bericht te verzenden.",
    support_success_msg: "Uw e-mailapp openen...",
    support_error_msg: "Kan bericht niet verzenden. Probeer het later opnieuw.",
    explorer_title: "Ontdekkingsreiziger",
    history_title: "Geschiedenis",
    animation_title: "Animatie",
    config_title: "Configuratie",
    tool_mouse: "Selecteer (Ctrl+M)",
    tool_brush: "Penseel (Ctrl+B)",
    tool_brush_mode: "Schakelmodus (continu/helder)",
    tool_eraser: "Gum (Ctrl+E)",
    tool_brush_size: "Pas de penseelgrootte aan",
    tool_bucket: "Vullen (Ctrl+F)",
    tool_eyedropper: "Pipet",
    tool_grid: "Raster (Ctrl+Shift+B)",
    tool_rotate: "Roteren (Ctrl+Shift+R)",
    tool_flip_h: "H omdraaien (Ctrl+Shift+H)",
    tool_flip_v: "V omdraaien (Ctrl+Shift+V)",
    tool_transpose: "Transponeren (Ctrl+Shift+T)",
    label_width: "Breedte",
    label_height: "Hoogte",
    label_frames: "Aantal frames",
    label_animation: "Animatiestijl",
    label_background_color: "Achtergrondkleur",
    label_interval: "Interval",
    tool_anim_config: "Animatieconfiguratie",
    label_new_width: "Nieuwe breedte",
    label_new_height: "Nieuwe hoogte",
    label_apply: "Toepassen",
    label_colors: "Kleuren",
    label_size: "Maat",
    label_tolerance: "Tolerantie",
    val_horizontal: "Horizontaal",
    val_vertical: "Verticaal",
    val_sequence: "Reeks",
    val_bounce: "Stuiteren",
    val_random: "Willekeurig",
    val_solid: "Stevig",
    val_clear: "Duidelijk",
    action_add_sheet: "Nieuw blad",
    action_import: "Importeren",
    action_export: "Exporteren",
    action_sort_projects: "Soort",
    sort_date_old: "Oudste eerst",
    sort_date_new: "Nieuwste eerst",
    sort_name_az: "Naam (A-Z)",
    sort_name_za: "Naam (Z-A)",
    action_new_sprite: "Nieuwe Sprite",
    action_new_project: "Nieuw project",
    modal_save_all_title: "Bewaar alle wijzigingen",
    modal_save_all_desc: "Selecteer de activa die u wilt opslaan:",
    modal_save_selected: "Geselecteerd opslaan",
    action_saved: "Opgeslagen",
    modal_create_sprite_title: "Maak een nieuwe Sprite",
    modal_create_project_title: "Nieuw project maken",
    modal_add_sheet_title: "Nieuw blad toevoegen",
    modal_rename_sheet_title: "Hernoem blad",
    modal_rename_sprite_title: "Hernoem Sprite",
    modal_delete_sprite_title: "Sprite verwijderen",
    modal_delete_project_title: "Project verwijderen",
    modal_delete_sheet_title: "Blad verwijderen",
    placeholder_sprite_name: "Naam",
    placeholder_project_name: "Naam",
    placeholder_sheet_name: "Naam",
    placeholder_new_name: "Nieuwe naam",
    action_create: "Creëren",
    action_add: "Toevoegen",
    action_rename: "Hernoemen",
    action_duplicate: "Duplicaat",
    action_delete: "Verwijderen",
    action_cancel: "Annuleren",
    confirm_delete_sprite: "Weet u zeker dat u deze sprite wilt verwijderen?",
    confirm_delete_project: "Weet u zeker dat u dit project wilt verwijderen? Alle sprites worden verwijderd.",
    confirm_delete_sheet: "Weet u zeker dat u dit blad wilt verwijderen?",
    err_select_sprite: "Selecteer eerst een sprite.",
    err_select_project: "Selecteer eerst een project.",
    err_name_empty: "Naam mag niet leeg zijn.",
    err_sprite_exists: "Er bestaat al een sprite met die naam.",
    err_project_exists: "Er bestaat al een project met die naam.",
    err_no_content: "Geen inhoud om op te slaan.",
    err_no_changes: "Geen wijzigingen om op te slaan.",
    err_delete_last_sheet: "Kan het laatste blad niet verwijderen.",
    err_extract_frames: "Kan geen frames extraheren.",
    err_indexeddb: "Kan niet lokaal worden opgeslagen. Uw browser ondersteunt IndexedDB mogelijk niet.",
    msg_upload_success: "Uploaden succesvol: {0}",
    msg_upload_failed: "Uploaden mislukt: {0}",
    msg_save_success: "Opslaan succesvol.",
    msg_saving: "Besparing...",
    msg_multi_save_result: "{0} items opgeslagen. {1} mislukkingen.",
    menu_title: "Menu",
    menu_save: "Redden",
    menu_save_all: "Bewaar alles",
    menu_support: "Neem contact op met ondersteuning",
    label_local_storage: "Lokale opslag",
    label_sign_in: "Inloggen",
    modal_export_title: "Sprite exporteren",
    label_filename: "Bestandsnaam",
    label_format: "Formaat",
    action_export_confirm: "Exporteren",
};

export default translations;
